export const Langs = [
    {display: 'English', value: 'en'},
    {display: 'Deutsch', value: 'de'},
    {display: 'Français', value: 'fr'},
    {display: 'Italiano', value: 'it'}
  ];

export const SUPPORTED_LANG_CODES = Langs.map(lang => lang.value);

export function isSupportedLanguage(lang: string | null | undefined): lang is string {
  return !!lang && SUPPORTED_LANG_CODES.indexOf(lang) !== -1;
}

export function languageFromQueryValue(raw: string | null | undefined): string | null {
  if (!raw) {
    return null;
  }
  const normalized = String(raw).trim().toLowerCase().replace('_', '-');
  if (SUPPORTED_LANG_CODES.indexOf(normalized) !== -1) {
    return normalized;
  }
  const prefix = normalized.split('-')[0];
  return SUPPORTED_LANG_CODES.indexOf(prefix) !== -1 ? prefix : null;
}

export function applyLanguageFromQuery(
  langParam?: string | null,
  languageParam?: string | null
): string {
  const fromQuery = languageFromQueryValue(langParam) || languageFromQueryValue(languageParam);
  if (fromQuery) {
    localStorage.setItem('language', fromQuery);
  }
  return resolveLanguage(localStorage.getItem('language'));
}

export function resolveLanguage(lang: string | null | undefined): string {
  return isSupportedLanguage(lang) ? lang : 'en';
}

export function languageDisplayName(lang: string | null | undefined): string {
  const match = Langs.find(item => item.value === lang);
  return match ? match.display : 'English';
}

export function toAcceptLanguage(lang: string | null | undefined): string {
  const code = resolveLanguage(lang);
  return code + '-' + code;
}
